/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   video-reviews.js
 *
 *   Desc:   Tablist widget that implements ARIA Authoring Practices
 */

'use strict';

class TabsManual {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab);
  }

  setSelectedTab(currentTab) {
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  moveFocusToTab(currentTab) {
    currentTab.focus();
  }

  moveFocusToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.moveFocusToTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index - 1]);
    }
  }

  moveFocusToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.moveFocusToTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.moveFocusToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.moveFocusToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.moveFocusToTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.moveFocusToTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  // Since this example uses buttons for the tabs, the click onr also is activated
  // with the space and enter keys
  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

// Initialize tablist

window.addEventListener('load', function () {
  var tablists = document.querySelectorAll('.section-reviews [role=tablist]');
  for (var i = 0; i < tablists.length; i++) {
    new TabsManual(tablists[i]);
  }

  const videoModal = document.getElementById('hfb-video-review-modal');
  const videoFrame = videoModal ? videoModal.querySelector('iframe') : null;
  const videoTitle = videoModal ? videoModal.querySelector('#hfb-video-review-modal-title') : null;
  const videoClose = videoModal ? videoModal.querySelector('.hfb-vr-modal__close') : null;
  let lastVideoTrigger = null;

  function isSafeVideoUrl(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:';
    } catch (e) {
      return false;
    }
  }

  function closeVideoReview() {
    if (!videoModal) return;
    if (videoFrame) videoFrame.src = '';
    if (typeof videoModal.close === 'function' && videoModal.open) {
      videoModal.close();
    } else {
      videoModal.removeAttribute('open');
    }
    if (lastVideoTrigger) {
      lastVideoTrigger.focus();
      lastVideoTrigger = null;
    }
  }

  function openVideoReview(url, title, trigger) {
    if (!videoModal || !videoFrame || !isSafeVideoUrl(url)) return;

    lastVideoTrigger = trigger || null;
    videoFrame.src = url;
    if (videoTitle) {
      videoTitle.textContent = title || 'Customer video review';
    }

    if (typeof videoModal.showModal === 'function') {
      videoModal.showModal();
    } else {
      videoModal.setAttribute('open', '');
    }

    if (videoClose) videoClose.focus();
  }

  if (videoModal) {
    if (videoClose) {
      videoClose.addEventListener('click', closeVideoReview);
    }
    videoModal.addEventListener('click', function (event) {
      if (event.target === videoModal) closeVideoReview();
    });
    videoModal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeVideoReview();
    });
  }

  if (location.hash && location.hash.indexOf('#qv') === 0) {
    history.replaceState(null, '', location.pathname + location.search);
    if (window.LOOX && typeof window.LOOX.closeModal === 'function') {
      window.LOOX.closeModal();
    }
  }

  document.querySelectorAll('.hfb-bvr').forEach(box => {
    const playReview = function () {
      const videoUrl = box.dataset.videoUrl;
      if (videoUrl) {
        openVideoReview(videoUrl, box.getAttribute('title'), box);
        return;
      }

      const url = box.dataset.fullLightbox;
      if (!url || !window.LOOX) return;

      let matches = /\/quickview\/(?<loox_id>[^?]+)\?/.exec(url);
      if (matches) {
        window.LOOX.openQV(matches.groups.loox_id);
      }
    };

    box.addEventListener('click', playReview);
    box.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        playReview();
      }
    });
  });

  const mainContainer = document.querySelector('.page-main-reviews');
  const pageSize = mainContainer.dataset.pageSize;
  
  document.querySelectorAll('.section-reviews .btn-view-more').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('.panel-category');
      
      let index = 0;
      panel.querySelectorAll('.hidden').forEach(block => {
        if (++index > pageSize) {
          return false;
        }
        
        block.classList.remove('hidden');
      });

      if ( panel.querySelectorAll('.hidden').length == 0 ) {
        btn.style.display = 'none';
      } 
    });
  })
});